import styled from '@emotion/styled';
import { COLORS } from '../../constants';

export const StyledLeftSide = styled.div`
  width: 348px;
  height: 760px;
  background-color: ${COLORS.lightBlue};
  position: absolute !important;
  border-radius: 10px 0 0 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;

  @media (max-width: 1023px) {
    position: relative !important;
    width: 100%;
    top: 0;
    height: auto;
    border-radius: 0;
    display: flex;
    flex-direction: column;
    padding-top: 40px;
  }
`;

export const StyledImageLogo = styled.img`
  position: absolute !important;
  width: 249px;
  height: 69px;
  left: 49px;
  top: 46px;

  @media (max-width: 1023px) {
    position: relative !important;
    width: 160px;
    height: auto;
    left: 0;
    top: 40px;
  }

  @media (max-width: 768px) {
    width: 140px;
  }

  @media (max-width: 414px) {
    width: 120px;
  }
  @media (max-width: 375px) {
    top: 100px;
  }
`;

export const StyledImageBoy = styled.img`
  width: 278px;
  height: 309px;
  bottom: 224px;
  left: 45px;
  position: absolute !important;

  @media (max-width: 1023px) {
    position: relative !important;
    bottom: -60px;
    width: 160px;
    height: auto;
    left: 0;
    margin: 0 auto;
    padding-bottom: 0px;

  @media (max-width: 768px) {
    width: 120px;
  }

  @media (max-width: 414px) {
    width: 100px;
  }
  @media (max-width: 375px) {
    bottom: -100px;
  }
`;
